import { defineMessages } from 'react-intl';

export default defineMessages({
    accountSummary: {
        id: 'portal.views.home-page-layout.Account Summary',
        defaultMessage: 'Account Summary',
    },
    myBalance: {
        id: 'portal.directives.templates.billing-summary-tiles.My Balance',
        defaultMessage: 'My Balance',
    },
    overdue: {
        id: 'portal.directives.templates.billing-summary-tiles.Overdue',
        defaultMessage: 'Overdue',
    },
    payNow: {
        id: 'portal.directives.templates.billing-summary-tiles.Pay Now',
        defaultMessage: 'Pay Now',
    },
    myNextBill: {
        id: 'portal.directives.templates.billing-summary-tiles.My Next Bill',
        defaultMessage: 'My Next Bill'
    },
    due: {
        id: 'portal.directives.templates.billing-summary-tiles.Due',
        defaultMessage: 'Due',
    },
    updateMyDetails: {
        id: 'portal.views.home-page-layout.Update My Profile',
        defaultMessage: 'Update My Profile'
    },
    lastPayment: {
        id: 'portal.directives.templates.billing-summary-tiles.My Last Payment',
        defaultMessage: 'My Last Payment',
    },
    paid: {
        id: 'portal.directives.templates.billing-summary-tiles.Paid',
        defaultMessage: 'Paid',
    },
    renewalInfo: {
        id: 'portal.views.home-page-layout.You have policies due for renewal.',
        defaultMessage: 'You have policies due for renewal.'
    },
    policies: {
        id: 'portal.views.home-page-layout.Policies',
        defaultMessage: 'Policies'
    },
    type: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.type',
        defaultMessage: 'Type'
    },
    statusActive: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.Active',
        defaultMessage: 'Active'
    },
    statusInForce: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.In Force',
        defaultMessage: 'In Force'
    },
    statusRenewed: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.Renewed',
        defaultMessage: 'Renewed'
    },
    status: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.status',
        defaultMessage: 'Status'
    },
    policy: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.policy',
        defaultMessage: 'Policy'
    },
    effective: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.effective',
        defaultMessage: 'Effective Period'
    },
    premium: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.premium',
        defaultMessage: 'Premium'
    },
    myQuickLinks: {
        id: 'portal.views.home-page-layout.My Quick Links',
        defaultMessage: 'My Quick Links'
    },
    printanIDCard: {
        id: 'portal.views.home-page-layout.Print an ID Card',
        defaultMessage: 'Print an ID Card'
    },
    makeAPayment: {
        id: 'portal.views.home-page-layout.Make a Payment',
        defaultMessage: 'Make a Payment'
    },
    setupAutomaticPayments: {
        id: 'portal.views.home-page-layout.Setup Automatic Payments',
        defaultMessage: 'Setup Automatic Payments'
    },
    changeMyPolicy: {
        id: 'portal.views.home-page-layout.ChangeMyPolicy',
        defaultMessage: 'Change My Policy'
    },
    fileClaim: {
        id: 'portal.views.home-page-layout.FileClaim',
        defaultMessage: 'File a Claim'
    },
    getAPersonalAutoQuote: {
        id: 'portal.views.home-page-layout.Get a Personal Auto Quote',
        defaultMessage: 'Get a Personal Auto Quote'
    },
    getAHomeOwnersQuote: {
        id: 'portal.views.home-page-layout.Get a Home Owners Quote',
        defaultMessage: 'Get a Home Owners Quote'
    },
    policyDetailsAgent: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.agent',
        defaultMessage: 'Agent'
    },
    policyDetailsTel: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.tel',
        defaultMessage: 'T.'
    },
    policyDetailsIdCard: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.id card',
        defaultMessage: 'ID Card'
    },
    policyDetailsFileClaim: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.fileClaim',
        defaultMessage: 'File a Claim'
    },
    myBalanceTileCurrent: {
        id: 'portal.directives.templates.billing-summary-tiles.Current',
        defaultMessage: 'Current'
    },
    policyNotShowing: {
        id: 'portal.views.home-page-layout.Do you have a policy with us but it is not showing?',
        defaultMessage: 'Do you have a policy with us but it is not showing?'
    },
    addPolicy: {
        id: 'portal.views.home-page-layout.Add Policy',
        defaultMessage: 'Add Policy'
    },
    riBalanceAmount: {
        id: "portal.directives.templates.billing-summary-tiles.My Balance",
        defaultMessage: "My Balance"
    },
    riBillingStatus: {
        id: "portal.directives.templates.billing-summary-tiles.Billing Status",
        defaultMessage: "Billing Status"
    },    
    riBalanceCurrentAmount: {
        id: "portal.directives.templates.billing-summary-tiles.Current",
        defaultMessage: "Current"
    },    
    riBalanceDate: {
        id: "portal.directives.templates.billing-summary-tiles.Due",
        defaultMessage: "Due"
    },    
    riLastPaymentAmount: {
        id: "portal.directives.templates.billing-summary-tiles.My Last Payment",
        defaultMessage: "My Last Payment"
    },    
    riLastPaymentDate: {
        id: "portal.directives.templates.billing-summary-tiles.Payment Date",
        defaultMessage: "Payment Date"
    },    
    riPriorPolicyBalance: {
        id: "portal.directives.templates.billing-summary-tiles.Prior Policy Balance",
        defaultMessage: "Prior Policy Balance"
    },    
    riPriorPolicyBalanceAmount: {
        id: "portal.directives.templates.billing-summary-tiles.Current",
        defaultMessage: "Current"
    },    
    riPriorPolicyBalanceDate: {
        id: "portal.directives.templates.billing-summary-tiles.Balance Date",
        defaultMessage: "Balance Date"
    },    
    riLossRunsLink: {
        id: 'portal.views.home-page-layout.Loss Runs',
        defaultMessage: 'Loss Runs'
    },     
    riFormsOrderingLink: {
        id: 'portal.views.home-page-layout.Forms Ordering',
        defaultMessage: 'Forms Ordering'
    },     
    riReportPayrollLink : {
        id: "portal.views.home-page-layout.Report Payroll",
        defaultMessage: "Report Payroll"
    },
    riContactsHeader : {
        id: "portal.views.home-page-layout.Republic Contacts",
        defaultMessage: "Republic Contacts"
    },         
    riWhatsNew : {
        id: "portal.views.home-page-layout.What's New",
        defaultMessage: "What's New"
    },         
    riPayAsYouGo : {
        id: "portal.views.home-page-layout.Pay-As-You-Go FAQ",
        defaultMessage: "Pay-As-You-Go FAQ"
    },         
    riClaimsOfficeLink : {
        id: "portal.views.home-page-layout.Claims Offices",
        defaultMessage: "Claims Offices"
    },         

    riThirdPartyLink : {
        id: "portal.views.home-page-layout.Third Party Administrators",
        defaultMessage: "Third Party Administrators"
    },         
    riBalanceCurrentAmount : {
        id: "portal.directives.templates.billing-summary-tiles.Min. Due",
        defaultMessage: "Min. Due"
    },        
    riOpenPayrollTableTitle : {
        id: "portal.views.home-page-layout.OpenPayroll.Open Payroll Reports",
        defaultMessage: "Open Payroll Reports"
    }, 
    riAuditStatementInTitle : {
        id: "portal.views.home-page-layout.Audit Statements",
        defaultMessage: "Audit Statements"
    },             
    serviceLocationColumn : {
        id: "policy.common.directives.templates.policy-account-open-payroll.serviceLocation",
        defaultMessage: "Service Location"
    },    
    reportingPeriodColumn : {
        id: "policy.common.directives.templates.policy-account-open-payroll.reportingPeriod",
        defaultMessage: "Reporting Period"
    },   
    dueDateColumn : {
        id: "policy.common.directives.templates.policy-account-open-payroll.dueDate",
        defaultMessage: "Due Date"
    },  
    reportColumn : {
        id: "policy.common.directives.templates.policy-account-policy-summaries.report ",
        defaultMessage: " "
    },       
    openPayrollTable : {
        id: "policy.common.directives.templates.policy-account-open-payroll.There are no Open Payroll Reports at this time",
        defaultMessage: "There are no Open Payroll Reports at this time"
    },
    paygPremierConnection: {
        id: "portal.views.home-page-layout.Pay-As-You-Go Premier Payroll Connections",
        defaultMessage: "Pay-As-You-Go Premier Payroll Connections"
    }
});
